import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var TextSvg = function TextSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#6356F6",
      fillRule: "evenodd",
      d: "M3.667 2h16.666C21.253 2 22 2.746 22 3.667v16.666c0 .92-.746 1.667-1.667 1.667H3.667C2.747 22 2 21.254 2 20.333V3.667C2 2.747 2.746 2 3.667 2m10.958 15.143a.866.866 0 0 0-.875-.857H5.875a.866.866 0 0 0-.875.857c0 .473.392.857.875.857h7.875a.866.866 0 0 0 .875-.857M19 13.714a.866.866 0 0 0-.875-.857H5.875a.866.866 0 0 0-.875.857c0 .474.392.857.875.857h12.25a.866.866 0 0 0 .875-.857m0-3.428a.866.866 0 0 0-.875-.857H5.875a.866.866 0 0 0-.875.857c0 .473.392.857.875.857h12.25a.866.866 0 0 0 .875-.857m0-3.429A.866.866 0 0 0 18.125 6H5.875A.866.866 0 0 0 5 6.857c0 .474.392.857.875.857h12.25A.866.866 0 0 0 19 6.857",
      clipRule: "evenodd"
    })
  });
};
export var Text = function Text(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: TextSvg
  }));
};